"use client";

import { useRouter, useSearchParams } from "next/navigation";

interface BackButtonProps {
  fallbackHref: string;
  fallbackLabel: string;
}

const fromLabels: Record<string, { label: string; href: string }> = {
  dashboard: { label: "Back to Dashboard", href: "/" },
  decisions: { label: "Back to Decisions", href: "/decisions" },
  reflection: { label: "Back to Reflection", href: "/reflections" },
  reflections: { label: "Back to Reflections", href: "/reflections" },
  pattern: { label: "Back to Pattern", href: "/patterns" },
  people: { label: "Back to People", href: "/people" },
};

export default function BackButton({ fallbackHref, fallbackLabel }: BackButtonProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const from = searchParams.get("from");

  const destination = from && fromLabels[from] ? fromLabels[from] : null;
  const label = destination?.label || `← ${fallbackLabel}`;

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push(destination?.href || fallbackHref);
    }
  };

  return (
    <button
      onClick={handleBack}
      className="inline-flex items-center text-sm text-zinc-500 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-200"
    >
      {destination ? `← ${destination.label}` : label}
    </button>
  );
}
